import { JsonType } from 'posthog-js';
import { ZodSchema, z } from 'zod';

export type SchemaWithDefaults<T extends ZodSchema<JsonType>> = {
  defaultEnabled: boolean;
  schema: T;
  defaultValue: z.infer<T>;
  requiresServerEvaluation?: boolean;
};

export const makeFeatureFlagPayloadValidator = <T extends JsonType>({
  defaultEnabled,
  defaultValue,
  schema,
  requiresServerEvaluation,
}: {
  schema: ZodSchema<T>;
  defaultValue: T;
  defaultEnabled: boolean;
  requiresServerEvaluation?: boolean;
}): SchemaWithDefaults<ZodSchema<T>> => {
  return {
    defaultEnabled,
    schema,
    defaultValue,
    ...(requiresServerEvaluation && { requiresServerEvaluation }),
  };
};
